<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left" class="mr-1"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="isDisabled || loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small/>
              <font-awesome-icon icon="save" class="mr-1"/>
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-skeleton-wrapper :loading="isBusy">
      <template #loading>
        <b-card no-body>
          <!-- Tabs -->
          <b-tabs card>
            <b-tab title="Персональные данные" disabled/>
            <b-tab title="Платежные реквизиты" disabled/>
            <b-tab title="Файлы документов" disabled/>
            <b-tab title="Паспортные данные" disabled/>
            <b-tab title="Расходы" disabled/>
            <b-tab title="Связи" disabled/>
          </b-tabs>
          <!-- Персональные данные -->
          <b-card border-variant="white">
            <b-row>
              <b-col lg="6">
                <b-card bg-variant="light">
                  <!-- Телефон -->
                  <b-row class="mt-1">
                    <b-col>
                      <b-skeleton width="10%" height="16%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                      <b-skeleton width="100%" height="15%"/>
                    </b-col>
                  </b-row>
                  <!-- ФИО -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="6%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <!-- ИНН -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="6%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <!-- Тип занятости -->
                  <b-row class="mb-2 pt-1">
                    <b-col>
                      <b-skeleton width="17%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <!-- СНИЛС -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="9%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <!-- Возраст -->
                  <b-row class="mb-1 pt-1">
                    <b-col>
                      <b-skeleton width="10%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <!-- Гражданство -->
                  <b-row>
                    <b-col>
                      <b-skeleton width="16%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="6">
                <b-card bg-variant="light">
                  <!-- Город -->
                  <b-row>
                    <b-col class="mb-2 mt-2">
                      <b-skeleton width="7%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="44%"/>
                    </b-col>
                  </b-row>
                  <!-- Адрес проживания -->
                  <b-row>
                    <b-col>
                      <b-skeleton width="21%" height="16%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                      <b-skeleton width="40%" height="15%" class="mb-0"/>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="27%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="44%"/>
                    </b-col>
                    <b-col>
                      <b-skeleton width="65%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="44%"/>
                    </b-col>
                  </b-row>
                  <!-- Умения -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="8%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Готовность -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="12%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="44%"/>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="17%" height="16%x" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                      <b-skeleton width="100%" height="15%"/>
                    </b-col>
                  </b-row>
                  <!-- Примечание -->
                  <b-row class="mb-4">
                    <b-col>
                      <b-skeleton width="17%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="107%"/>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-card>
      </template>

      <template #default>
        <b-card no-body>
          <b-form @submit.stop.prevent="handleSubmit">
            <b-tabs card>
              <b-tab title="Персональные данные" active>
                <b-row>
                  <b-col lg="6">
                    <b-card bg-variant="light">
                      <b-form-group
                        id="group-phone" :label="$t('message.workers.modal.phoneInput')"
                        description="Уникальный для каждого исполнителя. Если телефон не начинается с +7 укажите это в Примечании."
                      >
                        <b-input-group size="sm" prepend="+7">
                          <b-form-input
                            size="sm"
                            type="text"
                            :disabled="isDisabled"
                            :placeholder="$t('message.workers.modal.phonePlaceholder')"
                            :state="phoneState"
                            v-model="newItem.phone"
                          />
                          <b-form-invalid-feedback :state="phoneState">
                            {{phoneInvalidFeedback}}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group id="group-name" label="ФИО">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :state="getFieldState('name')"
                          :placeholder="$t('message.workers.modal.namePlaceholder')"
                          v-model="newItem.name"
                        />
                      </b-form-group>

                      <b-form-group id="group-inn" label="ИНН">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите ИНН"
                          v-model="newItem.inn"
                        />
                      </b-form-group>

                      <b-form-group id="group-employment-type" label="Тип занятости">
                        <b-form-select
                          size="sm"
                          :disabled="isDisabled"
                          :state="getFieldState('employment_type')"
                          v-model="newItem.employment_type"
                        >
                          <option v-for="option in employment_types" :value="option.id">
                            {{ option.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>

                      <b-form-group id="group-snils" label="СНИЛС">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите СНИЛС"
                          v-model="newItem.snils"
                        />
                      </b-form-group>

                      <b-row>
                        <b-col cols="6">
                          <b-form-group id="group-age" label="Пол">
                            <b-form-select
                              size="sm"
                              :disabled="isDisabled"
                              v-model="newItem.sex"
                            >
                              <option :value="true">Мужчина</option>
                              <option :value="false">Женщина</option>
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-form-group id="group-passport-type" label="Гражданство">
                        <citizenships-multi-select
                          v-model="newItem.citizenships"
                          :is-disabled="isDisabled"
                        />
                      </b-form-group>

                      <b-row class="align-items-center">
                        <b-col>
                          <b-form-group id="group-status" label="Статус">
                            <worker-status-select
                              :id="newItem.status_id"
                              @onSelect="onSelectWorkerStatus"
                              :is-disabled="isDisabled"
                              drop-up
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-form-checkbox v-model="newItem.active" :disabled="isDisabled" size="md" class="mt-3">Активен / Не активен</b-form-checkbox>
                    </b-card>
                  </b-col>
                  <b-col lg="6">
                    <b-card bg-variant="light">
                      <b-form-group id="group-town" label="Город">
                        <b-form-select
                          size="sm"
                          :disabled="isDisabled"
                          :state="getFieldState('town_id')"
                          v-model="newItem.town_id"
                        >
                          <option v-for="option in towns" :value="option.id">
                            {{ option.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>

                      <b-form-group id="group-address" label="Адрес проживания" description="Адрес текущего проживания исполнителя">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.addressPlaceholder')"
                          v-model="newItem.address"
                        />
                      </b-form-group>

                      <b-row>
                        <b-col>
                          <b-form-group id="group-worker-source" label="Источник">
                            <b-form-select
                              size="sm"
                              :disabled="isDisabled"
                              :state="getFieldState('worker_source_id')"
                              v-model="newItem.worker_source_id"
                            >
                              <option :value="0">Не выбран</option>
                              <option v-for="option in workerSources" :value="option.id">
                                {{ option.name }}
                              </option>
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group id="group-worker-source-comment" label="Источник комментарий">
                            <b-form-input
                              type="text"
                              size="sm"
                              :disabled="isDisabled"
                              v-model="newItem.worker_source_comment"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-form-group id="group-skills" :label="$t('message.workers.modal.skillInput')">
                        <worker-skill-multi-select
                          v-model="newItem.skills"
                          :is-disabled="isDisabled"
                        />
                      </b-form-group>

                      <b-form-group id="group-ready" :label="$t('message.workers.modal.readyInput')">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.readyPlaceholder')"
                          v-model="newItem.ready"
                        />
                      </b-form-group>

                      <b-form-group id="group-level-efficiency" label="Уровень КПД"
                        description="Высокий - все в норме. Средний - внимание, есть риск. Низкий - проблемный. При необходимости добавьте Примечание."
                      >
                        <b-form-select
                          class="mb-1 mr-2"
                          size="sm"
                          v-model="newItem.level_efficiency"
                          :disabled="isDisabled"
                          :options="levelEfficiencyOptions"
                        />
                      </b-form-group>

                      <b-form-group id="group-complaints" label="Нарекания">
                        <worker-complaint-select
                          :id="newItem.complaint"
                          @onSelect="onSelectWorkerComplaint"
                          :is-disabled="isDisabled"
                        />
                      </b-form-group>

                      <b-form-group id="group-description" :label="$t('message.workers.modal.descriptionInput')" class="mb-0">
                        <b-form-textarea
                          size="sm"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.descriptionPlaceholder')"
                          v-model="newItem.description"
                          :rows="3"
                          :max-rows="6"
                        />
                      </b-form-group>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Платежные реквизиты">
                <b-row>
                  <b-col lg="6">
                    <b-card bg-variant="light">
                      <b-table
                        :items="paymentItems"
                        :fields="paymentFields"
                        select-mode="single"
                        responsive="sm"
                        ref="paymentTable"
                        selectable
                        selectedVariant="success"
                        thead-class="hidden_header"
                        @row-selected="onPaymentRowSelected"
                      >
                        <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                            <font-awesome-icon :icon="['far', 'square-check']"/>
                          </template>
                          <template v-else>
                            <font-awesome-icon :icon="['far', 'square']"/>
                          </template>
                        </template>

                        <template #cell(details)="row">
                          <b-card bg-variant="light">
                            <b>
                              {{row.item.name}}
                            </b>
                            <div v-if="row.item.id === 1">
                              <b-form-group id="group-payments-sbp-phone-number" label="Телефон">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_sbp.sbp_phone"
                                />
                              </b-form-group>

                              <b-form-group id="group-payments-sbp-recipient-name" label="ФИО получателя">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_sbp.recipient_name"
                                />
                              </b-form-group>
                            </div>

                            <div v-if="row.item.id === 2">
                              <b-form-group id="group-payments-card-card-number" :label="$t('message.workers.modal.cart_numberInput')">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_card.card_number"
                                />
                              </b-form-group>
                            </div>

                            <div v-if="row.item.id === 3">
                              <b-form-group id="group-pay-account-number" label="Номер счёта">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_req.account_number"
                                />
                              </b-form-group>

                              <b-form-group id="group-payments-req-bik" label="БИК">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_req.bik"
                                />
                              </b-form-group>

                              <b-form-group id="group-payments-req-recipient-name" label="ФИО получателя">
                                <b-form-input
                                  size="sm"
                                  type="text"
                                  :readonly="isDisabled"
                                  v-model="newItem.payments_req.recipient_name"
                                />
                              </b-form-group>
                            </div>
                          </b-card>
                        </template>
                      </b-table>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Файлы документов">
                <b-card bg-variant="light">
                  <b-row>
                    <b-col lg="6">
                      <b-form-group id="group-passport" :label="$t('message.workers.modal.passport_urlInput')">
                        <b-form-file
                          ref="fileinput"
                          size="sm"
                          :placeholder="$t('message.workers.modal.passport_urlPlaceholder')"
                          :disabled="isDisabled"
                          v-if = !isShowFile(newItem)
                          v-model="passportFile"
                        />
                        <div id="input-passport-file" v-if = isShowFile(newItem) style="display: flex;align-items: center;justify-content: left;">
                          <b-img
                            style="cursor: pointer"
                            thumbnail
                            width="100"
                            height="100"
                            :src="previewUrl"
                            @click="downloadFile"
                          />
                          <b-btn v-if="!isDisabled" variant="danger" size="sm" class="mx-2 md-0" @click="onRemove(newItem)">
                            {{ $t("message.common.searchClear") }}
                          </b-btn>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-tab>
              <b-tab title="Паспортные данные">
                <b-row>
                  <b-col lg="6">
                    <b-card bg-variant="light">
                      <b-form-group id="group-passport-series" label="Серия">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите серию"
                          v-model="newItem.passport.passport_series"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-number" label="Номер">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите номер"
                          v-model="newItem.passport.passport_number"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-birthdate" label="Дата рождения">
                        <b-form-input
                          size="sm"
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.passport.birth_date"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-birthplace" label="Место рождения">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите место рождения"
                          v-model="newItem.passport.birth_place"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-issued-by" label="Кем выдан">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Кем выдан"
                          v-model="newItem.passport.issued_by"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-issue-date" label="Дата выдачи">
                        <b-form-input
                          size="sm"
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.passport.issue_date"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-department-code" label="Код подразделения">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Код подразделения"
                          v-model="newItem.passport.department_code"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-registration-address" label="Адрес регистрации">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Адрес регистрации"
                          v-model="newItem.passport.registration_address"
                        />
                      </b-form-group>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Расходы" v-if="isVisibleForRole()">
                <worker-costs ref="worker_costs" :is-disabled="isDisabled"></worker-costs>
              </b-tab>
              <b-tab title="Связи" v-if="isVisibleForRole()">
                <b-row>
                  <b-col lg="6" md="12">
                    <b-list-group size="sm">
                      <b-list-group-item class="d-flex justify-content-between align-items-center" :variant="getStaffVariant()">
                        Штатный сотрудник
                        <div>
                          <staff-select ref="staff_select" v-on:onSelect="updateStaffId"></staff-select>
                        </div>
                      </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                          <div>
                            Баланс ПРО
                            <br>
                            <span class="text-secondary text-small" v-if="workerIntegration != null">
                              Идентификатор {{workerIntegration.balans_pro_id}}
                            </span>
                          </div>
                          <div>
                            <div v-if="workerIntegration == null" class="d-flex justify-content-end align-items-center">
                              <b-form-input
                                id="input-inn"
                                size="sm"
                                type="text"
                                :disabled="isDisabled"
                                placeholder="Введите ИНН для поиска"
                                v-model="innIntegration"
                              />
                              <organization-select
                                id="input-org-select"
                                ref="organization_select"
                                class="ml-2"
                                style="width: 300px"
                                v-bind:initial-id="0"
                                v-on:onSelect="onSelectOrg"
                              />
                              <b-button class="ml-2" size="sm" variant="primary" @click="findBalansProWorkerHandler()">
                                Связать
                              </b-button>
                            </div>
                            <b-button v-if="workerIntegration != null" size="sm" variant="danger" @click="prepareUnlinkBalansProWorkerHandler()">
                              Отвязать
                            </b-button>
                          </div>
                       </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Последние Заявки">
                <b-table
                  class="mb-0 text-small"
                  striped
                  small
                  responsive
                  show-empty
                  :empty-text="$t('message.common.emptyTable')"
                  :items="lastTasks"
                  :fields="lastTasksFields"
                  head-variant="light"
                >
                  <template #cell(start_date)="row">
                    {{formatTableDateTime(row.item.start_date)}}
                  </template>
                </b-table>
              </b-tab>

              <b-tab title="Объекты" :disabled="newItem.id === 0">
                <template #title>
                 <span id="disabled-tab-target" style="pointer-events: auto; display: inline-block;">
                  Объекты
                </span>
                </template>
                <worker-locations ref="workers_locations" :is-disabled="isDisabled" />
              </b-tab>
            </b-tabs>
          </b-form>
        </b-card>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import workers from "../../network/workers";
import catalogs from "../../network/catalogs";
import balansPro from "../../network/balansPro";
import helpers from "../../utilites/helpers";
import dateFormatter from "../../utilites/dateFormatter";
import permissions, {PERM} from "../../utilites/permissions";
import LocationCosts from "../Locations/LocationCosts.vue";
import WorkerCosts from "../Workers/WorkerCosts.vue";
import StaffSelect from "../Staff/StaffSelect.vue";
import OrganizationSelect from "../Organizations/OrganizationSelect";
import VacancySelect from "../Catalogs/Vacancies/VacancySelect.vue";
import WorkerStatusSelect from "../Catalogs/WorkerStatuses/WorkerStatusSelect.vue";
import CitizenshipsMultiSelect from "../Catalogs/Citizenships/CitizenshipsMultiSelect";
import WorkerSkillMultiSelect from "../Catalogs/WorkerSkills/WorkerSkillMultiSelect";
import WorkerLocations from "../Workers/WorkerLocations";
import WorkerComplaintSelect from "../Catalogs/WorkerComplaints/WorkerComplaintSelect";

export default {
  name: 'Worker',
  components: {
    WorkerSkillMultiSelect,
    WorkerStatusSelect, VacancySelect, StaffSelect, LocationCosts, WorkerCosts, OrganizationSelect,
    CitizenshipsMultiSelect, WorkerLocations, WorkerComplaintSelect
  },
  mixins: [
    workers, catalogs, balansPro,
    helpers, dateFormatter, permissions
  ],
  props: ['worker_id','isRead'],
  data() {
    return {
      title:'Исполнитель',
      newItem: this.makeNewItem(),
      isDisabled: true,
      towns: [],
      workerSources: [],
      workerStatuses: [],
      workerComplaints: [],
      passportFile: null,
      previewUrl: null,
      isBusy: false,
      loading: false,
      employment_types: [
        {
          id: 1,
          name: 'СМЗ',
        },
        {
          id: 2,
          name: 'ГПХ',
        },
        {
          id: 3,
          name: 'ФЛ',
        },
        {
          id: 4,
          name: 'ИП',
        },
        {
          id: 5,
          name: 'В штате',
        },
      ],
      paymentFields: [
        {
          key: 'selected',
          class: 'worker-payment-width-selected',
        },
        {
          key: 'details',
        },
      ],
      paymentItems: [
        { id: 1, name: 'Оплата через СБП'},
        { id: 2, name: 'Оплата по номеру карты'},
        { id: 3, name: 'Оплата по реквизитам счёта'},
      ],
      workerIntegration: null,
      innIntegration: "",
      selectedOrgId: null,
      levelEfficiencyOptions: [
        { value: 'high', text: 'Высокий' },
        { value: 'medium', text: 'Средний' },
        { value: 'low', text: 'Низкий' },
      ],
      lastTasks: [],
      lastTasksFields: [
        {
          key: 'task_id',
          label: 'Заявка №',
        },
        {
          key: 'start_date',
          label: 'Дата',
        },
        {
          key: 'executor_name',
          label: 'Ответственный',
        },
        {
          key: 'location_name',
          label: 'Объект',
        },
        {
          key: 'customer_name',
          label: 'Заказчик',
        },
        {
          key: 'price',
          label: 'Цена за ед.',
          formatter: 'priceFormat'
        },
        {
          key: 'total_units',
          label: 'Кол-во',
        },
        {
          key: 'total_price',
          label: 'Цена',
          formatter: 'priceFormat'
        },
        {
          key: 'total_price',
          label: 'Цена',
        },
      ]
    }
  },
  async created() {
    this.isBusy = true;
    this.loading = true;
    this.towns = (await this.getTowns({})).data.items;
    this.workerSources = (await this.getWorkerSources({})).data.items;
    this.workerStatuses = (await this.getWorkerStatuses({})).data.items;
    this.workerComplaints = (await this.getWorkerComplaints({})).data.items;
    await this.updateView();

    await this.getLastTasks();
  },
  computed: {
    phoneState() {
      return /^\d{10}$/.test(this.newItem.phone);
    },
    phoneInvalidFeedback() {
      return 'Телефон должен состоять только из 10 цифр без пробелов и скобок.';
    },
  },
  watch: {
    passportFile(newFile) {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }

      if (newFile instanceof File || newFile instanceof Blob) {
        this.previewUrl = URL.createObjectURL(newFile);
      }
    }
  },
  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
  methods: {
    makeNewItem() {
      return {
        id: null,
        name: '',
        phone: '',
        address: '',
        sex: null,
        passport_type: '',
        passport_url: '',
        cart_number: '',
        rating: 0.0,
        active_today: false,
        active: true,
        description: '',
        group_id: 1,
        skill: '',
        ready: '',
        town_id: null,
        worker_source_id: 0,
        worker_source_comment: '',
        inn: '',
        snils: '',
        active_payment_type: null,
        passport: this.makePassport(),
        payments_sbp: this.makeSBPPayment(),
        payments_card: this.makeCardPayment(),
        payments_req: this.makeReqPayment(),
        staff_id: null,
        employment_type: null,
        level_efficiency: 'high',
        status_id: null,
        status_name: null,
        citizenships: [],
        skills: [],
        complaint: null,
      }
    },
    makePassport() {
      return {
        passport_series: null,
        passport_number: null,
        birth_date: null,
        birth_place: null,
        issued_by: null,
        issue_date: null,
        department_code: null,
        registration_address: null,
      }
    },
    makeSBPPayment() {
      return {
        sbp_phone: null,
        recipient_name: null,
        bank_name: null,
      }
    },
    makeCardPayment() {
      return {
        card_number: null,
        recipient_name: null,
      }
    },
    makeReqPayment() {
      return {
        account_number: null,
        bik: null,
        bank_name: null,
        recipient_name: null,
      }
    },
    async updateView() {
      this.isDisabled = this.$props.isRead;

      const workerId = this.$route.params.worker_id;

      if (workerId) {
        await this.getWorker(workerId);
      } else {
        this.clearNewItem();
        this.isBusy = false;
        this.loading = false;
      }
    },
    async getWorker(id) {
      const result = await this.getWorkerById(id);

      if (result.data != null) {
        this.isBusy = false;
        this.loading = false;
        await this.setNewItem(result.data);
      } else {
        this.clearNewItem();
        this.isBusy = false;
        this.loading = false;
      }

      if (this.$refs.worker_costs != null) {
        await this.$refs.worker_costs.configure(this.newItem.id);
      }

      if (this.$refs.workers_locations != null) {
        await this.$refs.workers_locations.configure(this.newItem.id);
      }
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/workers').catch(()=>{});
      }
    },
    clearNewItem() {
      Object.assign(this.newItem, this.makeNewItem());
      this.passportFile = null;
    },
    async setNewItem(item) {
      this.newItem = item;

      if (item.passport == null) {
        this.newItem.passport = this.makePassport();
      } else {
        if (this.newItem.passport.birth_date != null) {
          const birthDate = this.getDateFromServerString(this.newItem.passport.birth_date);
          this.newItem.passport.birth_date = this.formatDate(birthDate);
        }

        if (this.newItem.passport.issue_date != null) {
          const issueDate = this.getDateFromServerString(this.newItem.passport.issue_date);
          this.newItem.passport.issue_date = this.formatDate(issueDate);
        }
      }

      if (this.newItem.active_payment_type != null) {
        const rowIndex = this.newItem.active_payment_type - 1;
        if (this.$refs.paymentTable != null) {
          this.$refs.paymentTable.selectRow(rowIndex);
        }
      }

      if (item.payments_sbp == null) {
        this.newItem.payments_sbp = this.makeSBPPayment();
      }

      if (item.payments_card == null) {
        this.newItem.payments_card = this.makeCardPayment();
      }

      if (item.payments_req == null) {
        this.newItem.payments_req = this.makeReqPayment();
      }

      if (this.newItem.passport_url !== '') {
        const fileName = this.newItem.passport_url.split("/").pop();
        const result = await this.getWorkerFile(this.newItem.id);
        this.passportFile = new File([result.data], fileName);
      }

      if (this.$refs.staff_select != null) {
        if (this.newItem.staff_id != null) {
          await this.$refs.staff_select.configure(this.newItem.staff_id);
        }
      }

      await this.getWorkerBalansProIntegrationHandler();
    },
    async handleSubmit() {
      if (!this.newItem.town_id) {
        this.showSubmitError("Выберите город.");
        return;
      }

      if (!this.newItem.name) {
        this.showSubmitError("Укажите ФИО.");
        return;
      }

      if (this.newItem.worker_source_id === 0) {
        this.showSubmitError("Выберите источник исполнителя.");
        return;
      }

      if (!this.newItem.employment_type) {
        this.showSubmitError("Выберите тип занятости исполнителя.");
        return;
      }

      if (!this.phoneState) {
        this.showSubmitError("Телефон должен состоять только из 10 цифр без пробелов и скобок.");
        return;
      }

      if (this.newItem.passport.birth_date != null) {
        this.newItem.passport.birth_date = this.getDateToServer(this.newItem.passport.birth_date).toISOString();
      }

      if (this.newItem.passport.issue_date != null) {
        this.newItem.passport.issue_date = this.getDateToServer(this.newItem.passport.issue_date).toISOString();
      }

      if (this.$refs.worker_costs != null) {
        if (!this.$refs.worker_costs.items.every(v => v.worker_cost_type_id > 0)) {
          this.showSubmitError("Выберите тип расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.dateValidation(v.start_date))) {
          this.showSubmitError("Введите дату расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.dateValidation(v.end_date))) {
          this.showSubmitError("Введите дату расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.isNumberOrNull(v.sum))) {
          this.showSubmitError("Укажите сумму расходов в виде числа.");
          return;
        }
      }

      this.loading = true;
      this.updateStaffId();
      const data = { ...this.newItem };

      const method = (data.id > 0) ? this.putWorker : this.postWorker;
      const result = await method(data);

      if (result.status === 422) {
        this.showError("Заказчик с таким номер телефона уже существует. Найдите его в базе или введите другой номер телефона.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;

      if (this.$refs.worker_costs) {
        const costsResult = await this.$refs.worker_costs.saveCosts(this.newItem.id);

        if (costsResult.error != null) {
          this.showSubmitError("Ошибка сохранения расходов.");
          this.loading = false;
          return;
        }
      }

      if (this.passportFile) {
        const fileName = this.getFileName(this.passportFile, "passport");

        let formData = new FormData();
        formData.append('file', this.passportFile, fileName);

        const result = await this.postWorkerPassportFile(this.newItem.id, formData);

        if (result.error) {
          this.showError("Ошибка добавления файла", result.error.message);
          return;
        }

        this.loading = false;
        this.onBack();
        this.$emit('refresh');
      }

      this.loading = false;
      this.onBack();
      this.$emit('refresh');
    },
    getFileName(file, type) {
      const ext = "." + file.name.split('.').pop();
      return type + ext;
    },
    isShowFile(newItem) {
      return newItem.passport_url.length > 0;
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление файла";
      const message = `Вы действительно хотите удалить файл ${this.passportFile.name}?`;
      this.showModalDelete(title, message, function () {
        row.passport_url = '';
        this.passportFile = null;
      }.bind(this));
    },
    async downloadFile() {
      if (!this.newItem.passport_url) return;

      const fileName = this.newItem.passport_url.split("/").pop();
      const result = await this.getWorkerFile(this.newItem.id);

      if (result.error || !result.data) {
        this.showError("Ошибка загрузки файла", result.error.message);
        return;
      }

      this.handleFileDownload(result.data, fileName);
    },
    onPaymentRowSelected(items) {
      if (items.length === 0) {
        this.newItem.active_payment_type = null;
        return;
      }
      this.newItem.active_payment_type = items[0].id;
    },
    isVisibleForRole() {
      return this.hasPermission([PERM.WORKER_READ_OTHER]) || this.hasPermission([PERM.WORKER_EDIT_OTHER]);
    },
    updateStaffId() {
      if (this.$refs.staff_select != null) {
        if (this.$refs.staff_select.item == null) {
          this.newItem.staff_id = null;
          return;
        }

        if (this.$refs.staff_select.item.worker_id != null) {
          if (this.$refs.staff_select.item.worker_id !== this.newItem.id) {
            this.showError("Сотрудник уже связан с другим исполителем");
            this.$refs.staff_select.onClear();
            return;
          }
        }
        this.newItem.staff_id = this.$refs.staff_select.item.id;
      }
    },
    getStaffVariant() {
      return this.newItem.staff_id != null ? 'success' : 'default';
    },

    async getWorkerBalansProIntegrationHandler() {
      const data = {
        id: this.newItem.id
      }
      const result = await this.getWorkerBalansProIntegration(data);
      if (result.error != null) { return; }
      this.workerIntegration = result.data;
    },
    async findBalansProWorkerHandler() {
      const data = {
        //phone: "7" + this.newItem.phone,
        inn: this.innIntegration,
        orgId: this.selectedOrgId,
      }
      const result = await this.getBalansProWorker(data);
      if (result.error != null) {
        this.showError("Не удалось найти исполнителя", result.error.message);
        return;
      }
      const balansProUser = result.data;
      const balansProUserId = balansProUser.user.id;
      const accept = await this.showAcceptLink(balansProUser.user);
      if (accept) {
        await this.linkBalansProWorkerHandler(balansProUserId);
      }
    },
    async showAcceptLink(user) {
      const title = "Связь исполнителя с Баланс Про";
      const message = `
        Исполнитель "${this.newItem.name}" с id ${this.newItem.id}
        будет связан с Баланс Про "${user.full_name}" с id ${user.id}`;
      return await this.showAcceptModal(title, message, 'success');
    },
    async linkBalansProWorkerHandler(balansProId) {
      const data = {
        worker_id: this.newItem.id,
        balans_pro_id: balansProId,
      }
      const result = await this.linkBalansProWorker(data);
      if (result.error != null) {
        this.showError("Ошибка получение данных", result.error.message);
        return;
      }
      this.workerIntegration = result.data
    },
    async prepareUnlinkBalansProWorkerHandler() {
      const accept = await this.showAcceptUnlink();
      if (accept) {
        await this.unlinkBalansProWorkerHandler();
      }
    },
    async showAcceptUnlink() {
      const title = "Отвязка исполнителя от Баланс Про";
      const message = `
        Исполнитель "${this.newItem.name}" c id ${this.newItem.id}
        будет отвязан от Баланс Про с id ${this.workerIntegration.balans_pro_id}`;
      return await this.showAcceptModal(title, message);
    },
    async unlinkBalansProWorkerHandler() {
      const data = {
        id: this.workerIntegration.id
      }
      const result = await this.unlinkBalansProWorker(data);
      if (result.error != null) {
        this.showError("Ошибка получение данных", result.error.message);
        return;
      }
      this.workerIntegration = null;
    },
    onSelectOrg(orgId) {
      this.selectedOrgId = orgId;
    },
    async getLastTasks() {
      if (this.newItem.id == null) { return;}

      const result = await this.getWorkerLastTasks(this.newItem.id);

      if (result && result.data) {
        this.lastTasks = result.data;
      }
    },
    onSelectWorkerStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
        this.$set(this.newItem, 'status_name', status.name);
      } else {
        this.$set(this.newItem, 'status_id', 0);
        this.$set(this.newItem, 'status_name', '');
      }
    },
    onSelectWorkerComplaint(item) {
      if (item) {
        this.$set(this.newItem, 'complaint', item.id);
      } else {
        this.$set(this.newItem, 'complaint', 0);
      }
    }
  },
}
</script>

<style>
.hidden_header {
  display: none;
}

.worker-payment-width-selected {
  width: 80px;
  text-align: center;
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/Worker.vue